import React from 'react';
import MediumIcon from '../Images/medium-logo.png';
import GitHub from '../Images/GitHub.png';
import Linkedin from '../Images/Linkedin.webp';
import Twitter from "../Images/twitterIcon.webp";
import '../Styles/Footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className="grid grid-cols-4 text-left p-8 text-white">
                {/* SurferMonkey Section */}
                <div className="w-3/4">
                    <h3 className="text-2xl font-bold mb-12">
                        SurferMonkey
                    </h3>
                    <p className="text-lg">Blockchain Privacy and Compliance Abstraction</p>
                    <p className="text-base mt-10">© 2023 by SurferMonkey</p>
                </div>

                {/* Contact Section */}
                <div className="w-3/4">
                    <h3 className="text-2xl font-bold mb-12">
                        Contact
                    </h3>
                    <p className="hover-primary"><a href="mailto:hello@surfermonkey.io">hello@surfermonkey.io</a></p>
                </div>

                {/* Quick Menu Section */}
                <div className="w-3/4">
                    <h3 className="text-2xl font-bold mb-12">
                        Quick Menu
                    </h3>
                    {/* ... Add all the links here */}
                    <p className="hover-primary"><a href="https://playground.surfermonkey.io/" target="_self" rel="noreferrer" className="hover:font-bold">Home</a></p>
                    <p className="hover-primary"><a href="https://playground.surfermonkey.io/regulatory-dashboard" target="_self" rel="noreferrer" className="hover:font-bold">Regulatory Oversight</a></p>
                    <p className="hover-primary"><a href="https://playground.surfermonkey.io/FAQs" target="_self" rel="noreferrer" className="hover:font-bold">FAQs</a></p>
                    <p className="hover-primary"><a href="https://surfermonkey.gitbook.io/litepaper/" target="_blank" rel="noreferrer" className="hover:font-bold">Lite paper</a></p>
                    <p className="hover-primary"><a href="https://www.surfermonkey.io/" target="_blank" rel="noreferrer" className="hover:font-bold">Main site</a></p>
                    <p className="hover-primary"><a href="https://www.surfermonkey.io/about-us#:~:text=Be%20a%20part%20of%20the%20SurferMonkey%20story" target="_blank" rel="noreferrer" className="hover:font-bold">Contact</a></p>
                </div>

                {/* Socials Section */}
                <div className="w-3/4">
                    <h3 className="text-2xl font-bold mb-12">
                        Socials
                    </h3>
                    <div className="flex flex-wrap justify-between">
                        <div className="flex justify-between w-full mb-3">
                            {/* Twitter */}
                            <a href="https://twitter.com/SurferMonkeyHQ" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={Twitter}
                                    alt="Twitter SurferMonkey"
                                    className="w-10 h-10 cursor-pointer"
                                    style={{ marginRight: '20px' }} // Adjust as needed
                                />
                            </a>
                            {/* Medium */}
                            <a href="https://medium.com/@surferMonkeyHQ" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={MediumIcon}
                                    alt="Medium SurferMonkey"
                                    className="w-10 h-10 cursor-pointer"
                                    style={{ marginRight: '250px' }} // Adjust as needed
                                />
                            </a>
                        </div>
                        <div className="flex justify-start w-full">
                            {/* Github */}
                            <a href="https://github.com/SurferMonkey/surfermonkey.widget.v1.github.io" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={GitHub}
                                    alt="Github SurferMonkey"
                                    className="w-10 h-10 cursor-pointer"
                                    style={{ marginRight: '20px' }} // Adjust as needed
                                />
                            </a>
                            {/* Linkedin */}
                            <a href="https://www.linkedin.com/company/surfermonkey/" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={Linkedin}
                                    alt="Linkedin SurferMonkey"
                                    className="w-10 h-10 cursor-pointer"
                                />
                            </a>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    );
}

export default Footer;